import(/* webpackMode: "eager" */ "/codebuild/output/src1302824950/src/app/(auth)/layout.js");
